import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar } from 'lucide-react';
import { useLang } from '../../../context/LangContext';

const CALENDLY_URL = "https://calendly.com/elite-help";

export const AgentCTA = () => {
  const { t } = useLang();

  return (
    <section data-testid="agent-cta" className="py-24 bg-[#020209]">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div 
          className="relative p-12 rounded-3xl bg-gradient-to-br from-brand-green/10 via-brand-blue/5 to-brand-gold/10 border border-white/[0.05] text-center overflow-hidden"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {/* Background decoration */}
          <div className="absolute inset-0 opacity-30">
            <div className="absolute top-0 left-1/4 w-64 h-64 rounded-full bg-brand-green blur-[100px]" />
            <div className="absolute bottom-0 right-1/4 w-64 h-64 rounded-full bg-brand-gold blur-[100px]" />
          </div>

          <div className="relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              {t("agent.cta.title")}
            </h2>
            <p className="text-neutral-400 text-lg mb-8 max-w-xl mx-auto">
              {t("agent.cta.subtitle")}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              {/* Voir les tarifs -> /tarifs */}
              <Link
                to="/tarifs"
                data-testid="agent-cta-pricing"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl bg-gradient-to-r from-brand-green to-brand-blue text-white font-semibold transition-all hover:shadow-lg hover:shadow-brand-green/20"
              >
                {t("cta.primary")}
                <ArrowRight size={18} />
              </Link>
              {/* Réserver un appel -> Calendly */}
              <a
                href={CALENDLY_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="agent-cta-calendly"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl border border-white/[0.1] bg-white/[0.02] text-white font-semibold hover:bg-white/[0.05] transition-all"
              >
                <Calendar size={18} />
                {t("cta.secondary")}
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
